import {
  Component,
  h,
  Prop,
  Host,
  Element,
  ComponentInterface,
} from '@stencil/core';
import { sanitizeHTML } from '../../utils/htmlSanitizer';

@Component({
  tag: 'signet-tooltip',
  styleUrl: 'signet-tooltip.scss',
})
export class Tooltip implements ComponentInterface {
  $message: HTMLElement;
  tooltipId = `tooltip_${tooltipIds++}`;

  @Element() $el: HTMLElement;

  @Prop() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Prop() disable = false;
  /**
   * The text to be displayed in the tooltip.
   * It can be a string or HTML.
   * @example  
   * ```html
   * <signet-tooltip text="Hello World" />
   * <signet-tooltip text="<strong>Hello</strong> <em>World</em>" />
   */
     
  @Prop() text: string;

  componentDidRender() {
    this.addRichContent();
  }

  private addRichContent() {
    if (!this.disable)
      this.$message.innerHTML = sanitizeHTML(this.text) as string;
  }

  render() {
    const classes = {
      'signet-tooltip': true,
      disabled: this.disable,
    };

    const wrapperProps = {
      ['aria-describedby']: !this.disable && this.tooltipId,
      class: {
        text: true,
      },
      tabIndex: !this.disable ? 0 : null,
    };

    return (
      <Host class={classes}>
        <span {...wrapperProps}>
          <slot />
        </span>
        {!this.disable && (
          <span
            id={this.tooltipId}
            class={`message ${this.position}`}
            role="tooltip"
            ref={(el) => (this.$message = el)}
          ></span>
        )}
      </Host>
    );
  }
}

let tooltipIds = 0;
